import { useIntl } from "react-intl"

const months = [
	"phronesis.common.months.january.short",
	"phronesis.common.months.february.short",
	"phronesis.common.months.march.short",
	"phronesis.common.months.april.short",
	"phronesis.common.months.may.short",
	"phronesis.common.months.june.short",
	"phronesis.common.months.july.short",
	"phronesis.common.months.august.short",
	"phronesis.common.months.september.short",
	"phronesis.common.months.october.short",
	"phronesis.common.months.november.short",
	"phronesis.common.months.december.short",
]

const useShortMonths = () => {
	const intl = useIntl()

	return months.map((id) => intl.formatMessage({ id }))
}

export default useShortMonths
